import { Box, Collapse, IconButton, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { Figure } from '../../../../elements/figure/Figure';

type ShowHomeHolterInfoProps = {
    isOpen: boolean;
    onClick: () => void;
};

const images: {
    alt: string;
    labelText: string;
    url: string;
}[] = [
    {
        alt: 'home-holter-receive-package',
        labelText:
            'De Thuis Holter wordt per post naar de patiënt gestuurd. De patiënt moet zelf volledig wilsbekwaam zijn om dit onderzoek uit te voeren.',
        url: '/assets/images/home-holter-receive-package.svg',
    },
    {
        alt: 'home-holter-application',
        labelText:
            'Het is van belang dat je de patiënt goed inlicht. De verantwoordelijkheid hiervan ligt bij jouw huisartspraktijk. De holter moet binnen 1 maand weer teruggestuurd zijn.',
        url: '/assets/images/home-holter-application.svg',
    },
];

const boxStyles = {
    cursor: 'pointer',
    padding: '16px 0',
};

const collapseBoxStyles = {
    backgroundColor: 'rgb(235, 249, 254)',
    marginBottom: '18px',
    padding: '24px',
};

export function ShowHomeHolterInfo({ isOpen, onClick }: ShowHomeHolterInfoProps) {
    return (
        <>
            <Box
                alignItems="center"
                display="flex"
                justifyContent="space-between"
                onClick={onClick}
                sx={boxStyles}
            >
                <Text
                    as="div"
                    fontWeight="bold"
                    size="md"
                >
                    Let op: je gaat een Thuis Holter aanvragen
                </Text>
                <IconButton
                    icon={isOpen ? 'caret-up' : 'caret-down'}
                    iconColor="default"
                    labelText="Toggle collapse"
                    size="small"
                />
            </Box>
            <Collapse isOpen={isOpen}>
                <Box
                    display="block"
                    sx={collapseBoxStyles}
                >
                    <div className="row">
                        {images.map(({ alt, url, labelText }) => (
                            <div
                                className="col-md-12"
                                key={alt}
                            >
                                <Box
                                    alignItems="center"
                                    display="flex"
                                    flexDirection="column"
                                >
                                    <Figure
                                        alt={alt}
                                        imageUrl={url}
                                    />
                                    <StyledImageLabel size="sm">{labelText}</StyledImageLabel>
                                </Box>
                            </div>
                        ))}
                    </div>
                </Box>
            </Collapse>
        </>
    );
}

const StyledImageLabel = styled(Text)`
    display: block;
    text-align: center;
    margin-top: 16px;
    max-width: 360px;
`;
